import options from "../../resources/data/options";

class OptionsUtil {
  getOptions(key) {
    return options[key];
  }
}

const optionsUtil = new OptionsUtil();
export default optionsUtil;